const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const parseDateInput = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim();
    if (!normalized) {
      return null;
    }

    if (DATE_ONLY_PATTERN.test(normalized)) {
      return new Date(`${normalized}T00:00:00Z`);
    }

    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
};

export const formatDateInTimeZone = (value, timeZone, options, fallback = '—') => {
  const date = parseDateInput(value);
  if (!date) {
    return fallback;
  }

  const resolvedZone = timeZone || 'UTC';
  try {
    return new Intl.DateTimeFormat('ru-RU', { timeZone: resolvedZone, ...options }).format(date);
  } catch (error) {
    try {
      return new Intl.DateTimeFormat('ru-RU', options).format(date);
    } catch {
      return fallback;
    }
  }
};

export const formatDayMonth = (value, timeZone) =>
  formatDateInTimeZone(value, timeZone, { day: '2-digit', month: '2-digit' });

export const formatDayMonthYear = (value, timeZone) =>
  formatDateInTimeZone(value, timeZone, { day: '2-digit', month: '2-digit', year: 'numeric' });

export const getTimeZoneOffsetMinutes = (timeZone, date = new Date()) => {
  const resolvedZone = timeZone || 'UTC';
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: resolvedZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(date);

  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const zonedDate = new Date(
    `${lookup.year}-${lookup.month}-${lookup.day}T${lookup.hour}:${lookup.minute}:${lookup.second}Z`
  );

  return (date.getTime() - zonedDate.getTime()) / 60000;
};
